import { runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { t } from 'react-switch-lang';
import { requestGet } from '../../../services/real.backend';
import usersStorage from '../../../pages/Users/usersStorage';
import UserModel from '../../../models/UserModel';

export default function getUsers() {
  return requestGet('/api/users/list')
    .then((resp) => {
      if (resp && resp.users) {
        runInAction(() => {
          usersStorage.users = [];
          resp.users.map((incomeUser) => {
            const user = new UserModel(incomeUser);
            // user.id = incomeUser.id;
            // user.name = incomeUser.name;
            // user.soname = incomeUser.soname;
            // user.surname = incomeUser.surname;
            // user.login = incomeUser.username;
            // user.email = incomeUser.email;
            // user.emailVerified = incomeUser.emailVerified;
            // user.status = incomeUser.status;
            // user.avatar = incomeUser.avatar;
            // user.verified_at = incomeUser.verified_at;
            // user.deleted_at = incomeUser.deleted_at;
            // // user.remember_token = incomeUser.remember_token;
            // user.created_at = incomeUser.created_at;
            // user.updated_at = incomeUser.updated_at;
            // user.group_id = incomeUser.group_id;
            // user.staffName = incomeUser.staffName || '';
            usersStorage.users.push(user);
            return null;
          });
          usersStorage.isRequestProgress = false;
          // toast.success(t('global.refreshed'));
        });
      } else {
        runInAction(() => {
          usersStorage.isRequestProgress = false;
        });
      }
    });
}
